// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2I_S0","bigColWidth":"Table_bigColWidth__1S17B","biggerColWidth":"Table_biggerColWidth__2HNxU","row":"Table_row__1R4iu","col":"Table_col__SAR-1"};